<template>
	<div
		class="d-flex flex-column gap-5 border-xs rounded-5 py-6 px-6 border-neutral-200 section-container"
	>
		<div class="d-flex align-center gap-3">
			<DefineIcon :show-ok="isComplete" :icon="icon" />
			<h3 class="text-title-s font-weight-normal text-neutral-900">
				{{ title }}
			</h3>
		</div>
		<slot />
	</div>
</template>

<script setup lang="ts">
	interface Props {
		isComplete: boolean
		title: string
		icon: string
	}

	defineProps<Props>()
</script>

<style scoped></style>
